export enum Pages {
    Home = "Home",
    StartJoinGame = "StartJoinGame",
    Info = "Info",
    WaitingRoom = "WaitingRoom",
    GameRoom = "GameRoom",
    Winner = "Winner",
    DownloadPack = "DownloadPack",
    RoastInfo = "RoastInfo",
    RoastRedCards = "RoastRedCards",
    RoastBlackCards = "RoastBlackCards",
    RoastWinner = "RoastWinner"
}